/**
 * Created by Kaku.Guo on 2018/11/23.
 */
import React, {useState, useEffect, useReducer} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter, Switch, Route} from 'react-router';
import AssetDetailGallery from './gallery/AssetDetailGallery';
import AssetDetailContent from './content/AssetDetailContent';
import AssetDetailDesc from './description/AssetDetailDesc';
import AssetQuestions from './question/AssetQuestions';
import AssetReviews from './reviews/AssetReviews';
import AssetDetailComment from './comment/AssetDetailComment';
import {
    TabList,
    Tab,
    ReviewReportDialog,
    ReviewSummaryReducer,
    ReviewSummaryDialog,
    Beta,
    getMessage,
    ContextWrapper
} from '../index';
import {getReviewFromQuery} from '../review/reviewUtils';
import {ReviewActions} from '../../actions';

const getTabs = noReview => {
    const initTabs = [{id: 'tab-desc', title: 'Description', panelId: 'panel-desc', anchor: ''}];
    if (!noReview) {
        initTabs.push({
            id: 'tab-reviews',
            title: 'Reviews',
            panelId: 'panel-reviews',
            anchor: 'reviews',
            beta: false
        });
    }
    return initTabs.concat(
        {
            id: 'tab-questions',
            title: 'Questions',
            panelId: 'panel-questions',
            anchor: 'questions',
            beta: false
        },
        {
            id: 'tab-legacy-comments',
            title: 'Legacy Comments',
            panelId: 'panel-legacy-comments',
            ghost: true,
            anchor: 'legacy-comments'
        }
    );
};

const mapDispatchToProps = dispatch => ({
    getReviewDetail: model => dispatch(ReviewActions.getReviewDetail(model))
});

function AssetDetail(props) {
    const [activeTab, setActiveTab] = useState('tab-desc');
    const {data = {}, history, location, messages, match, getReviewDetail, isLearnAsset} = props;
    const {id, customAttributes = {}} = data;
    let buyLink = customAttributes.BuyLink;
    buyLink = buyLink ? buyLink.value : null;
    const tabs = getTabs(!!buyLink);

    useEffect(() => {
        const pathSnippets = location.pathname.split('/').filter(i => i);
        const lastPath = pathSnippets[pathSnippets.length - 1];
        const nextActiveTab = tabs.find(item => item.anchor === lastPath) || tabs[0];
        setActiveTab(nextActiveTab.id);
    }, [location.pathname]);

    const [reviewSummaryOptions, reviewSummaryDispatch] = useReducer(ReviewSummaryReducer);

    useEffect(() => {
        const reviewInQuery = getReviewFromQuery(location.search);
        if (id && reviewInQuery) {
            reviewSummaryDispatch({
                payload: {
                    isVisible: true,
                    type: reviewInQuery.type
                }
            });
            getReviewDetail({
                offerId: id,
                ...reviewInQuery
            });
        }
    }, []);

    const [preventScroll, setPreventScroll] = useState(false);
    const switchTab = (tab, needScroll) => {
        const anchor = tab.anchor;
        setPreventScroll(!needScroll);
        history.replace(`${match.url}${anchor ? `/${anchor}` : ''}${location.search}`);
    };

    const [prevTab, setPrevTab] = useState('questions');
    const getPrevTabText = () => {
        let messageCode;
        if (prevTab === 'questions') {
            messageCode = 'messages.com.epicgames.plugin.store.message.view_question';
        } else {
            messageCode = 'messages.com.epicgames.plugin.store.message.view_review';
        }
        return getMessage(messages, messageCode);
    };

    return (
        <div className={`asset-details-container offset-top ${isLearnAsset ? 'learn' : ''}`}>
            <ContextWrapper styleClass="asset-details">
                <AssetDetailGallery {...props} />
                <AssetDetailContent {...props} />
            </ContextWrapper>
            <section className="asset-content-container" id="review-content">
                <div className="asset-content container-fluid">
                    <TabList>
                        {tabs.map(tab => {
                            return tab.ghost ? null : (
                                <Tab
                                    activeTabId={activeTab}
                                    id={tab.id}
                                    key={tab.id}
                                    onClick={() => switchTab(tab)}
                                    panelId={tab.panelId}
                                    className={tab.class}>
                                    {tab.title}
                                    {tab.beta && <Beta />}
                                </Tab>
                            );
                        })}
                    </TabList>
                    <Switch>
                        <Route
                            exact
                            path={match.url}
                            render={() => <AssetDetailDesc {...props} />}
                        />
                        <Route
                            exact
                            path={`${match.url}/reviews`}
                            render={() => (
                                <AssetReviews
                                    preventScroll={preventScroll}
                                    showLegacyComments={() => {
                                        setPrevTab('reviews');
                                        switchTab({anchor: 'legacy-comments'});
                                    }}
                                />
                            )}
                        />
                        <Route
                            exact
                            path={`${match.url}/questions`}
                            render={() => (
                                <AssetQuestions
                                    preventScroll={preventScroll}
                                    showLegacyComments={() => {
                                        setPrevTab('questions');
                                        switchTab({anchor: 'legacy-comments'});
                                    }}
                                />
                            )}
                        />
                        <Route
                            exact
                            path={`${match.url}/legacy-comments`}
                            render={() => (
                                <AssetDetailComment
                                    messages={messages}
                                    assetData={data}
                                    commentObjectId={data.commentRatingId}
                                    renderFooter={() => (
                                        <a onClick={() => switchTab({anchor: prevTab}, true)}>
                                            {getPrevTabText()}
                                        </a>
                                    )}
                                />
                            )}
                        />
                    </Switch>
                </div>
                <ReviewReportDialog />
                <ReviewSummaryDialog
                    options={reviewSummaryOptions}
                    stateDispatch={reviewSummaryDispatch}
                />
            </section>
        </div>
    );
}
AssetDetail.propTypes = {
    match: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object,
    data: PropTypes.object,
    messages: PropTypes.object,
    getReviewDetail: PropTypes.func,
    isLearnAsset: PropTypes.bool
};
export default withRouter(connect(null, mapDispatchToProps)(AssetDetail));
